import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'coin-siemens-energy-coin-app',
  templateUrl: './coin-app.component.html',
  styleUrls: ['./coin-app.component.scss'],
  imports: [TranslateModule]
})
export class CoinAppComponent {
  readonly app = input<{
    name: string;
    icon: string;
  }>(undefined);
  readonly disabled = input<boolean>(undefined);
}
